export default __webpack_public_path__ + "static/media/landrover.b358eb05.jpg";